import { render, staticRenderFns } from "./ProjetoListagem.vue?vue&type=template&id=0b516f55&scoped=true&"
import script from "./ProjetoListagem.vue?vue&type=script&lang=js&"
export * from "./ProjetoListagem.vue?vue&type=script&lang=js&"
import style0 from "./ProjetoListagem.vue?vue&type=style&index=0&id=0b516f55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b516f55",
  null
  
)

export default component.exports